import InfiniteScroll from './directive';

/* istanbul ignore next */
InfiniteScroll.install = function (Vue) {
  Vue.directive(InfiniteScroll.name, InfiniteScroll);
};

const _InfiniteScroll: any = InfiniteScroll
export default _InfiniteScroll;
